module.exports = __webpack_public_path__ + "img/partner26.375a49c1.png";